export default __webpack_public_path__ + "static/media/K.0cfe1968.svg";